<template>
  <v-container id="directorios" tag="section">
    <base-v-component heading="Directorios del Sistema" />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{
          formTitle
        }}</v-btn>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="getDirectorios">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
        <!--DIALOGO EDITAR-->
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row wrap>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="directorio.nombre"
                      label="Nombre"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="directorio.descripcion"
                      label="Descripcion"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <input-subir-imagen
                      nombre="Imagen"
                      @imagen-subida="imagenSubida($event, 'imagen')"
                      :propImg="directorio.imagen"
                    />
                  </v-col>
                  <v-col cols="12">
                    <input-subir-imagen
                      nombre="Imagen listado"
                      @imagen-subida="imagenSubida($event, 'imagenListado')"
                      :propImg="directorio.imagenListado"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="directorios"
        :loading="loading"
        :search="search"
        disable-pagination:loading="loading"
      >
        <template v-slot:item.imagen="{ item }">
          <v-img
            v-if="item.imagen"
            :src="item.imagen"
            aspect-ratio="1"
            width="65px"
          ></v-img>
          <span v-else>sin imagen</span>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="yellow"
                  min-width="0"
                  small
                  v-on="on"
                  @click="facturacionDialog(item)"
                >
                  <v-icon class="black--text" small>mdi-currency-eur</v-icon>
                </v-btn>
              </template>
              <span>Configurar facturación</span>
            </v-tooltip>
            <v-btn
              class="px-2 ml-1"
              color="success"
              min-width="0"
              small
              @click="editItemDialog(item)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              class="px-2 ml-1"
              color="red"
              min-width="0"
              small
              @click="deleteItem(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
    <!--DIALOGO FACTURACIÓN-->
    <v-dialog v-model="dialogFacturacion.dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >Facturación del Directorio {{ dialogFacturacion.negocio }}</span
          >
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                  :loading="dialogFacturacion.loadingForm"
                  label="Modo de facturación"
                  :items="$store.state.facturacion.modoFacturacionDirectorio"
                  v-model="facturacion.modoFacturacion"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                v-if="facturacion.modoFacturacion == 'directorio'"
              >
                <v-select
                  :loading="dialogFacturacion.loadingForm"
                  label="Impuesto facturación concepto online"
                  :items="$store.getters['impuestos/getImpuestosSelect']"
                  v-model="facturacion.impuesto"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                v-if="facturacion.modoFacturacion == 'directorio'"
              >
                <v-text-field
                  :loading="dialogFacturacion.loadingForm"
                  v-model="facturacion.cuentaAsociada"
                  label="Id cuenta asociada Stripe"
                  append-icon="mdi-link"
                  @click:append="abrirEnlaceStripe"
                />
              </v-col>
            </v-row>
            <v-row v-if="facturacion.modoFacturacion == 'directorio'">
              <v-card width="50%" class="mx-auto">
                <v-list-item>
                  <v-list-item-avatar color="primary">
                    <v-icon class="white--text">mdi-currency-eur</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="headline"
                      >TASAS PAGO ONLINE</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >Se aplica a cada pago online y se retiene a la hora de
                      pasarlo a su cuenta asociada</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        type="number"
                        step="0.01"
                        label="Porcentaje por pedido pago online"
                        v-model="facturacion.tasaPorcentajePedidoPagoOnline"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        type="number"
                        step="0.01"
                        label="Valor fijo por pedido pago online"
                        v-model="facturacion.tasaFijaPedidoPagoOnline"
                      />
                    </v-col>
                  </v-row>
                  <!--tasaPorcentajePedido: 0,tasaFijaPedido: 0,tasaFijaServicio: 0-->
                </v-card-text>
              </v-card>
              <v-card width="50%" class="mx-auto">
                <v-list-item>
                  <v-list-item-avatar color="primary">
                    <v-icon class="white--text">mdi-currency-eur</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="headline"
                      >TASAS PEDIDO</v-list-item-title
                    >
                    <v-list-item-subtitle
                      >Se aplica a cada pedido y se facturará al terminar el
                      periodo</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        type="number"
                        step="0.01"
                        label="Porcentaje por pedido"
                        v-model="facturacion.tasaPorcentajePedido"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        type="number"
                        step="0.01"
                        label="Valor fijo por pedido pago online"
                        v-model="facturacion.tasaFijaPedido"
                      />
                    </v-col>
                  </v-row>
                  <!--tasaPorcentajePedido: 0,tasaFijaPedido: 0,tasaFijaServicio: 0-->
                </v-card-text>
              </v-card>
            </v-row>
            <v-divider />
            <v-row v-if="facturacion.modoFacturacion == 'directorio'">
              <v-card width="100%">
                <v-card-title>Datos Facturación</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-text-field label="CIF" v-model="facturacion.cif" />
                    </v-col>
                    <v-col cols="12" sm="8">
                      <v-text-field
                        label="Nombre"
                        v-model="facturacion.nombre"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="facturacion.direccion"
                        label="Dirección"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="facturacion.cp"
                        label="Código postal"
                      />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="facturacion.municipio"
                        label="Municipio"
                      />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="facturacion.provincia"
                        label="Provincia"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="emailsFacturacionComputados"
                        label="Emails de envio (separados por comas)"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-row>
            <!-- imágenes facturación -->
            <v-row>
              <v-col cols="12" sm="6">
                <v-row class="mx-2">
                  <p class="text-center subtitle-1">Imagen Logo</p>
                  <v-spacer />
                  <v-btn
                    :loading="loadingImagenAux"
                    small
                    class="red mr-4"
                    v-if="facturacion.imagenLogo"
                    @click="facturacion.imagenLogo = ''"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-btn
                    :loading="loadingImagenAux"
                    small
                    class="secondary"
                    @click="cambiarImagen('imagenLogo')"
                  >
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>
                  <v-file-input
                    class="d-none"
                    ref="imagenLogo"
                    color="deep-purple accent-4"
                    counter
                    label="File input"
                    placeholder="Imagen logo"
                    prepend-icon="mdi-paperclip"
                    outlined
                    v-model="imagenAux"
                    @change="cambiarImagenFichero('facturacion')"
                    :show-size="1000"
                  />
                </v-row>

                <v-img :src="facturacion.imagenLogo" max-height="150px" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-row class="mx-2">
                  <p class="text-center subtitle-1">Imagen marca de agua</p>
                  <v-spacer />
                  <v-btn
                    :loading="loadingImagenAux"
                    small
                    class="red mr-4"
                    v-if="facturacion.imagenMarcaAgua"
                    @click="facturacion.imagenMarcaAgua = ''"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-btn
                    :loading="loadingImagenAux"
                    small
                    class="secondary"
                    @click="cambiarImagen('imagenMarcaAgua')"
                  >
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>
                  <v-file-input
                    class="d-none"
                    ref="imagenMarcaAgua"
                    color="deep-purple accent-4"
                    counter
                    label="File input"
                    placeholder="Imagen logo"
                    prepend-icon="mdi-paperclip"
                    outlined
                    v-model="imagenAux"
                    @change="cambiarImagenFichero('facturacion')"
                    :show-size="1000"
                  />
                </v-row>

                <v-img :src="facturacion.imagenMarcaAgua" max-height="150px" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeFacturacion"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="saveFacturacion"
            :loading="dialogFacturacion.loadingForm"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
        
        <script>
import { mapState } from "vuex";
import InputSubirImagen from "../../components/admin/InputSubirImagen.vue";
export default {
  components: { InputSubirImagen },
  data() {
    return {
      dialog: false,
      loading: false,
      search: "",
      loadingForm: false,
      directorio: {
        id: null,
        nombre: "",
        descripcion: "",
        negocios: [],
        negociosAceptanPedidoConjunto: [],
        imagenListado: "",
        imagen: "",
      },
      headers: [
        {
          sortable: false,
          text: "Imagen",
          value: "imagen",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Descripción",
          value: "descripcion",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      dialogFacturacion: {
        dialog: false,
        id: "",
        negocio: "",
        loadingForm: false,
      },
      facturacion: {
        modoFacturacion: null,
        impuesto: null,
        cuentaAsociada: "",
        tasaPorcentajePedidoPagoOnline: 0,
        tasaFijaPedidoPagoOnline: 0,
        tasaPorcentajePedido: 0,
        tasaFijaPedido: 0,
        tasaFijaServicio: 0,
        nombre: "",
        cif: "",
        direccion: "",
        cp: "",
        municipio: "",
        provincia: "",
        emails: [],
      },
      imagenAux: null,
      loadingImagenAux: null,
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    "dialogFacturacion.dialog"(val) {
      val || this.closeFacturacion();
    },
  },
  computed: {
    emailsFacturacionComputados: {
      get() {
        return this.facturacion.emails
          ? this.facturacion.emails.toString().trim()
          : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.facturacion.emails = val.split(expresionRegular);
      },
    },
    itemsNegociosAceptanPedidoConjunto() {
      const negociosAux = this.directorio.negocios;
      return this.$store.state.app.negociosGestArray.filter((n) =>
        negociosAux.includes(n.value)
      );
    },
    formTitle() {
      return !!this.directorio.id ? "Editar Directorio" : "Nuevo Directorio";
    },
    ...mapState({
      directorios: (state) => state.directorios.directorios,
    }),
  },
  methods: {
    abrirEnlaceStripe() {
      this.loading = true;
      let _vm = this;
      return this.$store
        .dispatch("negocios/enlaceStripe", this.dialogFacturacion.id)
        .then((r) => {
          if (r.data && r.data.ok) {
            window.open(r.data.url, "_blank");
          }
          console.log(r);
        })
        .finally(() => {
          _vm.loading = false;
        });
    },
    async facturacionDialog(item) {
      this.dialogFacturacion.dialog = true;
      this.dialogFacturacion.negocio = item.nombre;
      this.dialogFacturacion.id = item.id;
      this.dialogFacturacion.loadingForm = true;
      const datosFact = await this.$store.dispatch(
        "directorios/getFacturacion",
        this.dialogFacturacion.id
      );
      this.dialogFacturacion.loadingForm = false;
      if (datosFact) this.facturacion = datosFact;
    },
    saveFacturacion() {
      const _vm = this;
      _vm.dialogFacturacion.loadingForm = true;
      this.$store
        .dispatch("directorios/saveFacturacion", {
          id: this.dialogFacturacion.id,
          facturacion: this.facturacion,
        })
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Datos de facturación grabados con éxito",
          });
          this.closeFacturacion();
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar los datos de facturación",
          });
        })
        .finally(() => {
          _vm.dialogFacturacion.loadingForm = false;
        });
    },
    closeFacturacion() {
      this.dialogFacturacion = {
        dialog: false,
        id: "",
        negocio: "",
        loadingForm: false,
      };
      this.facturacion = {
        modoFacturacion: null,
        cuentaAsociada: "",
      };
    },
    cambiarImagen(s) {
      this.imagenCambiando = s;
      this.$refs[s].$refs.input.click();
    },
    cambiarImagenFichero(pagina) {
      let _vm = this;
      _vm.loadingImagenAux = true;
      this.$store
        .dispatch("propio/subirImagen", {
          //tipo: this.imagenCambiando,
          imagen: this.imagenAux,
        })
        .then((img) => {
          const array = pagina.split("/");
          let aux = this;
          array.forEach((e) => {
            aux = aux[e];
          });
          aux[this.imagenCambiando] = img;
        })
        .finally(() => (_vm.loadingImagenAux = false));
    },
    imagenSubida(v, prop) {
      this.directorio[prop] = v;
    },
    imagenListadoSubida(v) {
      this.directorio.imagenListado = v;
    },
    save() {
      this.loadingForm = true;
      this.$store
        .dispatch("directorios/saveDirectorio", this.directorio)
        .then((res) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Directorio grabado con éxito",
          });
          this.getDirectorios();
          this.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar el directorio",
          });
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    getDirectorios() {
      this.loading = true;
      return this.$store.dispatch("directorios/getDirectorios").finally(() => {
        this.loading = false;
      });
    },
    showDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    editItemDialog(item) {
      this.dialog = true;
      this.directorio = item;
      this.directorio.imagenSrc = item.imagen ? item.imagen : "";
      this.directorio.imagenListadoSrc = item.imagenListado
        ? item.imagenListado
        : "";
    },
    reiniciarDatos() {
      this.directorio = {
        id: null,
        nombre: "",
        descripcion: "",
        negocios: [],
        negociosAceptanPedidoConjunto: [],
        imagenListado: null,
        imagenListadoSrc: "",
        imagen: null,
        imagenSrc: "",
      };
    },
  },
  mounted() {
    this.getDirectorios();
  },
};
</script>
        
        <style>
</style>